import React from "react";
import { useLang } from "../i18n/LanguageContext";
import { useSEO } from "../lib/useSEO";
import { Container, SectionHeading } from "../components/site/ui";

export default function Privacy() {
  const { t, lang } = useLang();
  const p = t.privacy;
  useSEO({ title: p.metaTitle, description: p.metaDesc, path: "/privacy-policy", lang });

  return (
    <div>
      <section className="pt-28 pb-12 border-b border-cool-dark" data-testid="privacy-hero">
        <Container>
          <SectionHeading title={p.title} />
          <p className="mt-4 text-xs font-mono text-cool-mid">{p.updated}: 06/2026</p>
        </Container>
      </section>

      <section className="py-16" data-testid="privacy-body">
        <Container className="max-w-3xl">
          <div className="space-y-10">
            {p.body.map((b, i) => (
              <div key={i}>
                <h2 className="font-display text-xl text-white">{b.t}</h2>
                <p className="mt-2 text-cool-light leading-relaxed">{b.d}</p>
              </div>
            ))}
          </div>
        </Container>
      </section>
    </div>
  );
}
